import { render, staticRenderFns } from "./e-models-cols-map.vue?vue&type=template&id=2bec77f1&scoped=true&lang=pug&"
import script from "./e-models-cols-map.vue?vue&type=script&lang=js&"
export * from "./e-models-cols-map.vue?vue&type=script&lang=js&"
import style0 from "./e-models-cols-map.vue?vue&type=style&index=0&id=2bec77f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec77f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
